<h2 mat-dialog-title>{{ data.allowRoleChoice ? 'Provision staff user' : 'Add teacher' }}</h2>
<mat-dialog-content>
  <form [formGroup]="form" class="teacher-form">
    <small class="text-danger" *ngIf="msg">{{ msg }}</small>
    <mat-form-field *ngIf="data.allowRoleChoice" appearance="outline" class="full">
      <mat-label>Role</mat-label>
      <mat-select formControlName="role" required>
        <mat-option value="ROLE_TEACHER">Teacher</mat-option>
        <mat-option value="ROLE_ADMIN">Admin</mat-option>
      </mat-select>
    </mat-form-field>
    <mat-form-field appearance="outline" class="full">
      <mat-label>Username</mat-label>
      <input matInput formControlName="username" autocomplete="username" required />
      <mat-error *ngIf="form.get('username')?.errors?.minlength">At least 3 characters</mat-error>
    </mat-form-field>
    <div class="row2">
      <mat-form-field appearance="outline">
        <mat-label>First name</mat-label>
        <input matInput formControlName="firstName" autocomplete="given-name" required />
      </mat-form-field>
      <mat-form-field appearance="outline">
        <mat-label>Last name</mat-label>
        <input matInput formControlName="lastName" autocomplete="family-name" required />
      </mat-form-field>
    </div>
    <mat-form-field appearance="outline" class="full">
      <mat-label>Email</mat-label>
      <input matInput type="email" formControlName="email" autocomplete="email" required />
      <mat-error *ngIf="form.get('email')?.errors?.email">Invalid email</mat-error>
    </mat-form-field>
    <mat-form-field appearance="outline" class="full">
      <mat-label>Phone (optional)</mat-label>
      <input matInput formControlName="phoneNumber" autocomplete="tel" />
    </mat-form-field>
    <mat-form-field appearance="outline" class="full">
      <mat-label>Temporary password</mat-label>
      <input
        matInput
        formControlName="password"
        [type]="hidePassword ? 'password' : 'text'"
        autocomplete="new-password"
        required
      />
      <button
        mat-icon-button
        matSuffix
        type="button"
        (click)="hidePassword = !hidePassword"
        [attr.aria-label]="'Toggle password visibility'"
      >
        <mat-icon>{{ hidePassword ? 'visibility_off' : 'visibility' }}</mat-icon>
      </button>
      <mat-hint>User signs in with username + this password until reset.</mat-hint>
      <mat-error *ngIf="form.get('password')?.errors?.minlength">At least 6 characters</mat-error>
    </mat-form-field>
  </form>
</mat-dialog-content>
<mat-dialog-actions align="end">
  <button mat-button type="button" (click)="cancel()">Cancel</button>
  <button mat-flat-button color="primary" type="button" (click)="submit()" [disabled]="form.invalid || saving">
    {{ saving ? 'Creating…' : 'Create account' }}
  </button>
</mat-dialog-actions>
